import { render, staticRenderFns } from "./13.vue?vue&type=template&id=4a4954c0&"
import script from "./13.vue?vue&type=script&lang=js&"
export * from "./13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports